"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _button = require("@design/ui/button");
var _dialog = require("@design/ui/dialog");
var _label = require("@design/ui/label");
var _textarea = require("@design/ui/textarea");
var _toggleGroup = require("@design/ui/toggle-group");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var FEEDBACK_TAGS = [{
  value: "Rule Misapplication",
  display: "Rule shouldn't have applied"
}, {
  value: "Incorrect Redline",
  display: "Redline is wrong"
}, {
  value: "Misplaced Redline",
  display: "Redline is in the wrong place"
}, {
  value: "Missing Rule",
  display: "Rule should have applied"
}, {
  value: "Overtriggered Rule",
  display: "Rule triggered too many times"
}, {
  value: "Incorrect Comment",
  display: "Comment is wrong"
}, {
  value: "Misplaced Comment",
  display: "Comment is in the wrong place"
}, {
  value: "Undertriggered Rule",
  display: "Rule triggered too few times"
}];
var FeedbackForm = function FeedbackForm(_ref) {
  var item = _ref.item,
    onDelete = _ref.onDelete,
    onSubmit = _ref.onSubmit;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    details = _useState2[0],
    setDetails = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedTags = _useState4[0],
    setSelectedTags = _useState4[1];
  var detailsFieldId = (0, _react.useId)();
  (0, _react.useEffect)(function () {
    if (item) {
      setDetails(item.details);
      setSelectedTags(item.tags);
    }
  }, [item]);
  var handleSelectTags = function handleSelectTags(tags) {
    item.tags = tags;
    setSelectedTags(tags);
  };
  var handleDetails = function handleDetails(details) {
    item.details = details;
    setDetails(details);
  };
  function submitFeedback(event) {
    event.preventDefault();
    onSubmit();
  }
  var tagPicker = /*#__PURE__*/(0, _jsxRuntime.jsx)(_toggleGroup.ToggleGroup, {
    type: "multiple",
    variant: "outline",
    size: "sm",
    className: "w-full flex-wrap",
    value: selectedTags,
    onValueChange: handleSelectTags,
    children: FEEDBACK_TAGS.map(function (tag) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_toggleGroup.ToggleGroupItem, {
        value: tag.value,
        children: tag.display
      }, tag.value);
    })
  });
  var detailsField = /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex flex-col gap-2",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_label.Label, {
      htmlFor: detailsFieldId,
      children: "Details"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_textarea.Textarea, {
      id: detailsFieldId,
      className: "min-h-25 resize-none",
      placeholder: "Add specific details",
      value: details !== null && details !== void 0 ? details : "",
      onChange: function onChange(e) {
        return handleDetails(e.target.value);
      }
    })]
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dialog.DialogHeader, {
      "data-sentry-element": "DialogHeader",
      "data-sentry-source-file": "FeedbackForm.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dialog.DialogTitle, {
        "data-sentry-element": "DialogTitle",
        "data-sentry-source-file": "FeedbackForm.tsx",
        children: "Provide feedback"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("form", {
      onSubmit: submitFeedback,
      className: "contents",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col gap-4",
        children: [tagPicker, detailsField]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dialog.DialogFooter, {
        "data-sentry-element": "DialogFooter",
        "data-sentry-source-file": "FeedbackForm.tsx",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
          type: "button",
          variant: "destructive",
          onClick: onDelete,
          "data-sentry-element": "Button",
          "data-sentry-source-file": "FeedbackForm.tsx",
          children: "Delete feedback"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
          type: "submit",
          "data-sentry-element": "Button",
          "data-sentry-source-file": "FeedbackForm.tsx",
          children: "Submit feedback"
        })]
      })]
    })]
  });
};
var _default = exports.default = FeedbackForm;